import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`I love to build new projects to learn new technologies and customize other projects to blend.`}</p>
    <p>{`While I keep praticing new things, I still take look in other projects that made me fall in love to explore more and more.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      